/**
 * 功能说明：用于处理postMessage接收到的消息
 */
import { signal } from "@/utils/index";
import { Message } from 'element-ui';
import { getShortId } from '@/utils'
import { getClientInfoId } from "@/api/crm";
import { popScreenWithOutOutbound } from "@/assets/js/wincall-init";
import { sendQdMsg } from "@/utils/qidian";
import i18n from '@/i18n'
export default {
  mounted() {
    window.addEventListener("message", this.postMsgListener);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.postMsgListener);
  },
  methods: {
    /**
     * 0、接收postMessage传递过来的消息
     *  e.data 有两种格式：json字符串(来自己manage)和对象(ekt)
     * */
    postMsgListener(e) {
      let POST_TYPE = this._config.POST_MSG_TYPE;
      const { APP_NOTIFY = {}} = this._config;
      const {
        isEnableStrongNotice = true,
      } = APP_NOTIFY;
      const { origin, data: postMsg = "" } = e;
      let msgData = null;

      if (["", "unchanged", "changed", "react-devtools"].includes(postMsg)) {
        return;
      }
      // 开发调试器
      if (postMsg.source && postMsg.source.includes("-devtools") || postMsg.hasOwnProperty('vueDetected') || postMsg.type == 'ajaxInterceptor') {
        return;
      }

      try {
        msgData = typeof postMsg == "string" ? JSON.parse(postMsg) : postMsg;
      } catch (error) {
        console.log("error:" + error + ", postMsgData:" + postMsg);
        return;
      }

      if (msgData.update_message == 1) {
        this.updateUnReadMsgCount();
        return;
      }

      // console.log(e,'postMsg 判断哪里接收到的', location.href)

      if(origin.substr(-13) == 'qidian.qq.com'){
        msgData = msgData.payload
      }

      let type = (msgData.type || 0) + '';

      // 处理知识库引用、发送到会话中
      if(['importKnow','sendKnow'].includes(type)){
        if(this.activeTabKey == 'chat'){
          const iframe_chat_window = document.getElementById('iframe_chat').contentWindow
          iframe_chat_window.postMessage(postMsg,'*')
        }else{
          Message({
            type: 'warning',
            message: i18n.t('wincall.noSessionForKnow'),
          })
        }
        return
      }
      switch (type) {
        case POST_TYPE.CLOSE_TAB:
          // 关闭tab 页面
          {
            let current_title = msgData.title || '';
            let delObj = {
              key: current_title,
            };

            // 兼容处理嵌入访客侧发送的type=1的信息
            !msgData.flag && this.delTab(delObj);
          }
          break;

        case POST_TYPE.CLOSE_DIALOG:
          // 关闭 ekt对话框
          this.changeDialogInfo({
            title: '',
            visible: false,
            src: ''
          })
          break;

        case POST_TYPE.MAKE_CALL:
          //电话
          {
            const { phone, userdata = {} } = msgData;
            if (phone != "") {
              // 企点环境中：cc-sub页面通知cc页面要打电话
              if(location.hash.includes('qidian/agent')){
                const obj = {
                  type: 'ExtApp.TopMenu',
                  method: 'sendMessage',
                  payload: {phone, userdata,type:POST_TYPE.MAKE_CALL}
                }
                sendQdMsg(obj)
              }else{
                signal.dialByTabMessage(phone, "", userdata);
              }
            }
          }
          break;

        case POST_TYPE.SEND_MSG:
          //短信
          {
            let phone = msgData.phone || "";
            // if (phone != "") {
              // sys_send_sms(phone);
              const { my: { ektv3_page }, } = this._config.URL;
              this.changeDialogInfo({
                title: i18n.t('wincall.smsTitle'),
                visible: true,
                src: `${ektv3_page}/ekt/sms/send/${phone}`
              })
            // }
          }

          break;

        case POST_TYPE.OPEN_MODAL:
          // 打开modal框
          {
            let { title, url, width, height } = msgData || {};
            if (url != "") {
              this.changeDialogInfo({
                title: title,
                visible: true,
                src: url,
                width: width,
                height: height
              })
            }
          }

          break;

        case POST_TYPE.ADD_TAB:
          // 打开tab
          {
            const { key = "", title = "", url = "", menu_icon = "menu_icon",...others } = msgData;
            if(others.call_out_setting === 1 && others.phone) {
              // 如果是新工单手机号字段外呼，只弹屏不拨打电话
              console.log(i18n.t('wincall.newTicketCallOut'))
              popScreenWithOutOutbound(others.phone, { call_out_setting: 1 })
              return;
            } else if (title != "" && url != "") {
              let addTabItem = {
                key: key || title,
                name: title,
                url: url,
                icon: menu_icon,
                ...others
              };
              // 兼容处理会话页签打开：由于页签是基于key的，菜单中打开时有key，而通过postMessage打开时，无法确定key，只给了页签的标题
              if(addTabItem.key == '会话'){
                addTabItem.key = 'chat'
                this._Bus.$emit('_busToggleMenu', true)
              }

              // 如果提供菜单定位路径，就可以尝试去定位菜单
              if(addTabItem.mainMenuKey && addTabItem.subActive){
                this._Bus.$emit('clickTab',addTabItem)
              }
              this.addTab(addTabItem);
            }
          }
          break;

        case POST_TYPE.VIEW_IMG:
          console.log(msgData.url)
          this.url = msgData.url
          this.srcList = [msgData.url]

          this.$nextTick(() => {
            this.$refs.viewImg.clickHandler()
          })
          break;

        case POST_TYPE.SHINE_ICON:
          // isEnableBrowserTabNotice: 该配置项在用户管理中设置
          const { isEnableBrowserTabNotice = true } = this.userInfo.notice || {}
          //闪烁ico
          if (isEnableBrowserTabNotice && (typeof window.shineObj != "undefined")) {
            window.shineObj.newsCome();
          } else {
            console.log(shineObj + "---shineObj");
          }
          break;

        case POST_TYPE.NOTICE:
          var title = msgData.title || "";
          var url = msgData.url || "";
          var body = msgData.body || "";
          var auto_close = msgData.auto_close || "";
          var tab_title = msgData.tab_title || "";
          // 会话消息
          if(origin.includes('intelcc-agent')){
            if(isEnableStrongNotice && (document.visibilityState == 'hidden' || this.activeTabKey !== 'chat')){
              this.pushNotice(title, body, url, auto_close, tab_title);
            }
          }else {
            this.pushNotice(title, body, url, auto_close, tab_title);
          }
          break;

        case POST_TYPE.TRC_WEB_CHANGE_SIZE:
        case POST_TYPE.MAKE_RTC_CALL:
        case POST_TYPE.OPEN_RTC_PANEL:
          console.log(i18n.t('wincall.rtcCommunication'))
          break;

        case POST_TYPE.SEAT_MONITOR_OPERATE:
          if(location.hash.includes('qidian/agent')){
            const obj = {
              type: 'ExtApp.TopMenu',
              method: 'sendMessage',
              payload: msgData || {}
            }
            sendQdMsg(obj)
          } else {
            const { agNo, actionType } = msgData || {};
            const Monitor = window.cti && window.cti.Monitor
            if(Monitor) {
              if(actionType === 1) { // 监听
                Monitor.spy({ monitoredAgNo: agNo })
              } else if(actionType === 2) { // 强插
                Monitor.barge({ monitoredAgNo: agNo })
              } else if(actionType === 3) { // 强拆
                Monitor.disconnect({ monitoredAgNo: agNo })
              }
            }
          }
          break;

        case POST_TYPE.NEW_CALL_POP_SCREEN:
          {
            try {
              const callRecords = this.$store.state.callRecords
              const { my: { crm_page } } = this._config.URL;
              const { eventName, callData = {} } = msgData || {};
              const { mt_info } = callData
              const mtInfo = mt_info && typeof mt_info == "string" ? JSON.parse(decodeURIComponent(mt_info)) : null
              const index = callRecords.findIndex((item) => item.call_id === callData.call_id)
              if(index === -1) {
                if(mtInfo) {
                  callRecords.unshift({
                    id: getShortId(),
                    result: 0,
                    isCalling: true,
                    call_type: mtInfo.CallType,
                    call_id: callData.call_id,
                    cle_name: '',
                    cle_id: '',
                    cus_phone: callData.phone,
                    area_name: mtInfo.CallerAreaName,
                    start_time: mtInfo.Time,
                    result_name: mtInfo.status || '--',
                    custom_status_arr: [eventName],
                    mtInfo
                  })
                  this.$store.dispatch('setCallRecords', [...callRecords])
                  const params = {
                    // cle_phone: callData.phone
                    phone: callData.phone
                  }
                  if(mtInfo.UserData) {
                    const { is_crm, ext_id, cle_id, client_id } = mtInfo.UserData;
                    if(is_crm == '1' && ext_id) {
                      params.cle_id = ext_id
                    }
                    if(!params.cle_id) {
                      params.cle_id = cle_id || client_id
                    }
                  }
                  getClientInfoId(crm_page, params).then(res => {
                    const callRecords = this.$store.state.callRecords
                    const { code, data } = res
                    // if (code === 200 && data.match_clients == 'null') return
                    // if (code === 200 && data.match_clients.length > 0) {
                    //   const index = callRecords.findIndex((item) => item.call_id === callData.call_id)
                    //   if(index !== -1) {
                    //     callRecords.splice(index, 1, {
                    //       ...callRecords[index],
                    //       cle_name: data.match_clients[0].cle_name,
                    //       cle_id: data.match_clients[0].id,
                    //     })
                    //     this.$store.dispatch('setCallRecords', [...callRecords])
                    //   }
                    // }
                    if (typeof data == 'object') {
                      const index = callRecords.findIndex((item) => item.call_id === callData.call_id)
                      if (index !== -1) {
                        callRecords.splice(index, 1, {
                          ...callRecords[index],
                          cle_name: data.cle_name,
                          cle_id: data.cle_id,
                          client_info: {
                            cle_is_vip: data.cle_is_vip
                          }
                        })
                        this.$store.dispatch('setCallRecords', [...callRecords])
                      }
                    }
                  }).finally(() => {
                    this._Bus.$emit("clickTab", { mainMenuKey: 'cc_workbench' });
                    this.$nextTick(() => {
                      this._Bus.$emit("callCommingIn", { call_id: callData.call_id });
                    });
                  })
                }
              } else {
                if(eventName === 'phoneConnect') {// 接通
                  const index = callRecords.findIndex((item) => item.call_id === callData.call_id)
                  if(index !== -1) {
                    callRecords.splice(index, 1, {
                      ...callRecords[index],
                      custom_status_arr: [...callRecords[index].custom_status_arr, eventName],
                      result_name: i18n.t('wincall.connected')
                    })
                    this.$store.dispatch('setCallRecords', [...callRecords])
                  }
                } else if(eventName === 'phoneHangup') { // 挂机
                  const index = callRecords.findIndex((item) => item.call_id === callData.call_id)
                  if(index !== -1) {
                    const isConnect = callRecords[index].custom_status_arr.includes('phoneConnect')
                    callRecords.splice(index, 1, {
                      ...callRecords[index],
                      result: isConnect ? 0 : undefined,
                      isCalling: false,
                      result_name: isConnect ? i18n.t('wincall.connected') : i18n.t('wincall.notConnected'),
                      custom_status_arr: [...callRecords[index].custom_status_arr, eventName],
                    })
                    this.$store.dispatch('setCallRecords', [...callRecords])
                  }
                }
              }
            } catch (error) {
              console.error(error);
              throw 'NEW_CALL_POP_SCREEN: ' + error
            }
          }
          break;

        default:
          var title = msgData.title || "";
          var url = msgData.url || ''

          url = (url.indexOf("http") !== -1 ? url : origin + url) || "";

          var menu_icon = msgData.icon || "menu_icon";
          if (title != "" && url != "" && origin != "") {
            let addTabItem = {
              key: String(title),
              name: title,
              url: url,
              icon: menu_icon,
            };
            this.addTab(addTabItem);
          }
          break;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/postMsg.js